import { lazy } from 'react';
import Loadable from 'ui-component/Loadable';
import AuthGuard from 'utils/route-guard/AuthGuard';

const BrainLanding = Loadable(lazy(() => import('views/dashboard/BrainLanding')));

// ==============================|| BRAIN ROUTE (no MainLayout) ||============================== //

const BrainRoutes = {
  path: '/brain',
  element: (
    <AuthGuard>
      <BrainLanding />
    </AuthGuard>
  )
};

export default BrainRoutes;
